import { cva, css } from "../../../styled-system/css";

export const wrapperRecipe = cva({
  base: {
    width: "100%",
    zIndex: 1,
    left: 0,
    color: "black",
    textAlign: "center",
    top: "baseUnit.mobile8",
    mobile: {
      top: "baseUnit.mobile10",
    },
    desktop: {
      fontSize: "heading.H6.desktop",
    },
  },
  variants: {
    theme: {
      default: {
        backgroundColor: "darkGreen",
        padding: 0,
        mobile: {
          padding: "6px 0",
        },
      },
      halloween: {
        backgroundColor: "halloweenPurple",
        padding: "20px",
        desktop: {
          padding: "baseUnit.mobile2",
        },
      },
      blackFriday: {
        backgroundColor: "black",
        padding: "20px",
        desktop: {
          padding: "baseUnit.mobile2",
        },
      },
    },
  },
  defaultVariants: {
    theme: "default",
  },
});

export const headlineRecipe = () =>
  css({
    fontWeight: "bold",
    letterSpacing: "body.mouse",
    color: "white",
  });

export const headline2Recipe = () =>
  css({
    color: "white",
  });

export const counterWrapperRecipe = cva({
  base: {
    display: "flex",
    fontWeight: "300",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "baseUnit.mobile3",
    gap: "baseUnit.mobile3",
    fontSize: "heading.H1.mobile",
    desktop: {
      gap: "baseUnit.mobile4",
      fontSize: "heading.H1.desktop",
    },
    "& div": {
      position: "relative",
      width: "58px",
      "&:not(:last-of-type)": {
        _before: {
          content: '":"',
          color: "currentColor",
          position: "absolute",
          top: "-2px",
          right: "-15px",
          fontSize: "heading.H1.mobile",
          desktop: {
            top: "-5px",
            right: "-21px",
            fontSize: "heading.H1.desktop",
          },
        },
      },
    },
    "& p": {
      margin: "baseUnit.mobile2 0 0",
      color: "white",
      fontSize: "body.mouse",
      fontWeight: "normal",
    },
  },
  variants: {
    theme: {
      default: {
        color: "white",
      },
      halloween: {
        color: "strongOrange",
      },
      blackFriday: {
        color: "red",
      },
    },
  },
  defaultVariants: {
    theme: "default",
  },
});

export const imageWrapperRecipe = () =>
  css({
    display: "none",
    desktop: {
      display: "inline-block",
      width: "188px",
      height: "80px",
      position: "absolute",
      marginLeft: "auto",
      marginRight: "auto",
      top: "baseUnit.mobile3",
      left: "40%",
      right: 0,
    },
  });
